import { FieldValuesMap } from '../../../types/policy';
import { claimDateFields } from '../data';
import { FORM_NAME } from '../data/constants';
import { FormBuilder, FormShape } from '../types';
import { ClaimFormTransformer } from '../types/ClaimsFormTransformer';
import { dateConversion } from '../utils';

const getClaimsForm = (props: ClaimFormTransformer, name = FORM_NAME.claim) => {
	const { claim, claimConfiguration } = props;
	const { fields: claimFields } = claimConfiguration;
	const { fieldGroupsByLocator, mediaByLocator, fieldValues } = claim;

	const incidentDateValue = dateConversion.dateTimestampToStoredDateString(
		claim.incidentTimestamp,
		'day',
	);
	const notificationDateValue = dateConversion.dateTimestampToStoredDateString(
		claim.notificationTimestamp,
		'day',
	);

	const fields = [...claimFields];

	fields.unshift(claimDateFields[1]);
	fields.unshift(claimDateFields[0]);

	const values = {
		...fieldValues,
		incidentDate: [incidentDateValue],
		notificationDate: [notificationDateValue],
	} as FieldValuesMap;
	return {
		[name]: {
			fields,
			fieldGroupsByLocator,
			mediaByLocator,
			values: values,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export default getClaimsForm;
